import routerLogin from "@/tenants/NLS/routes/login.js";
import routerUser from "@/tenants/NLS/routes/user.js";

const routes = [
	{
		path: "/",
		component: () => import("@/tenants/NLS/views/main/Index"),
		meta: { layout: "Blank"},
		beforeEnter: () => {
      history.back();
    },
	},
	...routerLogin,	
	...routerUser,
];

export {
	routes
};
